export interface Environment {
    pod: string;
    region: string;
    account: string;
    environment: string;
}

export const getEnvironment = (): Environment => {
    const { hostname } = window.location;

    const pieces = hostname.split('.');

    const environment: Environment = {
        account: pieces[0],
        pod: process.env.REACT_APP_POD || 'pod-3',
        region: process.env.REACT_APP_REGION || 'us-east-1',
        environment: process.env.REACT_APP_ENVIRONMENT || 'dev'
    };

    if (process.env.REACT_APP_ACCOUNT && process.env.NODE_ENV === 'development') {
        environment.account = process.env.REACT_APP_ACCOUNT;
    }

    return environment;
};
// These are production environments
export const IsAnyProdEnvironment = () => ['prod', 'fedramp', 'pfprod', 'hipaa'].includes(process.env.REACT_APP_ENVIRONMENT!);
// These are environments that don't have the POD_ENVIRONMENT in their base URL e.g. school.classgov.com vs school.testenv.class.com 
export const IsAnyTLDEnvironment = () => ['prod', 'fedramp', 'pfprod'].includes(process.env.REACT_APP_ENVIRONMENT!);
